import { BaseAPI } from "./BaseAPI";

import type { APIConf } from "./BaseAPI";
import type {
  CreateNotificationParams,
  DeleteNotificationParams,
  GetNotificationListParams,
  NotificationRow,
  UpdateNotificationParams,
} from "./NotificationAPI.types";

class NotificationAPIClass extends BaseAPI {
  constructor(conf: APIConf) {
    super(conf);
    this.service = "project";
    this.version = "v3";
  }

  get notificationsRoute(): string {
    return `${this.routeBase}/admin/storefront_projects/push_notifications`;
  }

  async getNotificationList({
    projectSlug,
  }: GetNotificationListParams): Promise<NotificationRow[]> {
    const { data } = await this.axios.get<NotificationRow[]>(
      this.notificationsRoute,
      { headers: { "xx-ok-project": projectSlug } },
    );

    if (!Array.isArray(data)) {
      throw new Error("Unexpected push notifications response");
    }

    return data;
  }

  async createNotification({
    projectSlug,
    payload,
  }: CreateNotificationParams): Promise<void> {
    await this.axios.post(this.notificationsRoute, payload, {
      headers: { "xx-ok-project": projectSlug },
    });
  }

  async updateNotification({
    projectSlug,
    uuid,
    notification,
  }: UpdateNotificationParams): Promise<void> {
    await this.axios.put(`${this.notificationsRoute}/${uuid}`, notification, {
      headers: { "xx-ok-project": projectSlug },
    });
  }

  async deleteNotification({
    projectSlug,
    uuid,
  }: DeleteNotificationParams): Promise<void> {
    await this.axios.delete(`${this.notificationsRoute}/${uuid}`, {
      headers: { "xx-ok-project": projectSlug },
    });
  }
}

const NotificationAPI = new NotificationAPIClass({
  token: localStorage.token,
});

export default NotificationAPI;
